export default "__VITE_ASSET__0LWygovX__"